import React from 'react';
import type { StudioThemeId } from 'fym-shared/src/music24/studioThemes';
import { TypedMemo } from '../../../../common/types';
import type { StudioThemeState } from '../studioRules';
import { FullVideoPlanNote } from '../FullVideoPlanNote';

interface RailNoticeProps {
  themeId: StudioThemeId;
  state: StudioThemeState;
  isOwner: boolean;
}

/**
 * Why "Make it" is off in the rail (design s7c): a full video or the motion artwork on Free shows
 * the Artist plan note. Nothing for other states.
 */
const RailNoticeComponent: React.FC<RailNoticeProps> = ({ themeId, state, isOwner }) => {
  if (state === 'needsPlan') {
    return <FullVideoPlanNote themeId={themeId} isOwner={isOwner} />;
  }
  return null;
};

export const RailNotice = TypedMemo(RailNoticeComponent);
